// removed by extract-text-webpack-plugin
module.exports = {"root":"Charts_option-with-tick_root---aLhIZ","icon":"Charts_option-with-tick_icon---eBUVD","is-selected":"Charts_option-with-tick_is-selected---2AX4p"};